import { augmentedWrap } from './utils';

export const addTheme = (content, selectedVariant, preserveOverrides) =>
  augmentedWrap(content)
    .updateStyle('config.style', { theme: selectedVariant }, preserveOverrides)
    .set('config.theme', `${selectedVariant}.pointer`)
    // Remove special keys that are defined in the theme
    .deleteProperties(
      [
        'config.pointerBase',
        'config.pointerCornerRadius',
        'config.pointerLength',
      ],
      preserveOverrides
    )
    .value();
